/**
 * Order service API
 *
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderSystemCommentShared } from './orderSystemCommentShared';
import { OrderDeliveryInfoResponse } from './orderDeliveryInfoResponse';
import { SlaPerformance } from './slaPerformance';
import { JsonNode } from './jsonNode';
import { OrderPromocode } from './orderPromocode';
import { OrderSkuLineResponse } from './orderSkuLineResponse';
import { PaymentResponse } from './paymentResponse';
import { BuyerContact } from './buyerContact';
import { CancelReason } from './cancelReason';
import { DigitalArtefactInfo } from './digitalArtefactInfo';
import { PaymentRefundResponse } from './paymentRefundResponse';
import { OrderFlowShared } from './orderFlowShared';
import { OrderModificationResponse } from './orderModificationResponse';


export interface OrderResponse {
    id?: number;
    unitedOrderId?: number;
    reserveId?: number;
    warehouseId?: number;
    currency?: OrderResponse.CurrencyEnum;
    digitalArtefactInfos?: Array<DigitalArtefactInfo>;
    sellerId?: number;
    legalSeller?: boolean;
    buyerId?: number;
    cancelReason?: CancelReason;
    cancelExtendedComment?: string;
    disputeId?: number;
    reviewId?: number;
    slaPerformance?: SlaPerformance;
    buyerType?: OrderResponse.BuyerTypeEnum;
    buyerRating?: number;
    contactPerson?: BuyerContact;
    status?: OrderResponse.StatusEnum;
    terminated?: boolean;
    terminatedAt?: Date;
    statusUpdatedAt?: Date;
    payments?: Array<PaymentResponse>;
    orderActions?: Array<OrderResponse.OrderActionsEnum>;
    createdAt?: Date;
    updatedAt?: Date;
    totalSumWithoutDiscount?: number;
    totalSum?: number;
    initialTotalSum?: number;
    itemsTotalWithoutDiscount?: number;
    itemsTotalWithoutVat?: number;
    totalDiscount?: number;
    deliveryPrice?: number;
    negotiationSum?: number;
    totalVat?: number;
    sellerVatCoefficient?: number;
    deliveryMethod?: OrderDeliveryInfoResponse;
    orderFlows?: Array<OrderFlowShared>;
    paymentRefunds?: Array<PaymentRefundResponse>;
    orderModifications?: Array<OrderModificationResponse>;
    paymentMethod?: OrderResponse.PaymentMethodEnum;
    paymentProvider?: OrderResponse.PaymentProviderEnum;
    part?: number;
    items?: Array<OrderSkuLineResponse>;
    buyerComment?: string;
    sellerComment?: string;
    operatorComment?: string;
    systemComment?: OrderSystemCommentShared;
    additionalFields?: { [key: string]: any; };
    promocode?: OrderPromocode;
    isChallan?: boolean;
    type?: OrderResponse.TypeEnum;
    chatId?: number;
}
export namespace OrderResponse {
    export type CurrencyEnum = 'RUB' | 'USD' | 'GEL' | 'KZT' | 'AZN' | 'INR' | 'SAR' | 'TMT' | 'XOF' | 'ZAR' | 'CHF' | 'NGN' | 'EGP' | 'KHR' | 'CNY';
    export const CurrencyEnum = {
        RUB: 'RUB' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        GEL: 'GEL' as CurrencyEnum,
        KZT: 'KZT' as CurrencyEnum,
        AZN: 'AZN' as CurrencyEnum,
        INR: 'INR' as CurrencyEnum,
        SAR: 'SAR' as CurrencyEnum,
        TMT: 'TMT' as CurrencyEnum,
        XOF: 'XOF' as CurrencyEnum,
        ZAR: 'ZAR' as CurrencyEnum,
        CHF: 'CHF' as CurrencyEnum,
        NGN: 'NGN' as CurrencyEnum,
        EGP: 'EGP' as CurrencyEnum,
        KHR: 'KHR' as CurrencyEnum,
        CNY: 'CNY' as CurrencyEnum
    };
    export type BuyerTypeEnum = 'COMMON_BUYER' | 'COMMON_SELLER' | 'LEGAL_BUYER' | 'LEGAL_SELLER' | 'OPERATOR' | 'COMMON_AGENT' | 'LEGAL_AGENT' | 'UNKNOWN' | 'MODERATOR' | 'TECHNICAL_USER' | 'COURIER';
    export const BuyerTypeEnum = {
        COMMON_BUYER: 'COMMON_BUYER' as BuyerTypeEnum,
        COMMON_SELLER: 'COMMON_SELLER' as BuyerTypeEnum,
        LEGAL_BUYER: 'LEGAL_BUYER' as BuyerTypeEnum,
        LEGAL_SELLER: 'LEGAL_SELLER' as BuyerTypeEnum,
        OPERATOR: 'OPERATOR' as BuyerTypeEnum,
        COMMON_AGENT: 'COMMON_AGENT' as BuyerTypeEnum,
        LEGAL_AGENT: 'LEGAL_AGENT' as BuyerTypeEnum,
        UNKNOWN: 'UNKNOWN' as BuyerTypeEnum,
        MODERATOR: 'MODERATOR' as BuyerTypeEnum,
        TECHNICAL_USER: 'TECHNICAL_USER' as BuyerTypeEnum,
        COURIER: 'COURIER' as BuyerTypeEnum
    };
    export type StatusEnum = 'CREATED' | 'AWAITING_CONFIRMATION' | 'AWAITING_PAYMENT' | 'CONFIRMED_PAYMENT' | 'PARTIALLY_PAID' | 'SHIPPED' | 'DELIVERED' | 'ISSUED' | 'CANCELED' | 'CANCELED_BY_SELLER' | 'CANCELED_BY_OPERATOR' | 'AWAITING_ASSEMBLY' | 'ASSEMBLY' | 'ASSEMBLED' | 'WAITING_DELIVERY' | 'RETURNED' | 'TIMEOUT' | 'BUY_IN_CREDIT' | 'STORED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION' as StatusEnum,
        AWAITING_PAYMENT: 'AWAITING_PAYMENT' as StatusEnum,
        CONFIRMED_PAYMENT: 'CONFIRMED_PAYMENT' as StatusEnum,
        PARTIALLY_PAID: 'PARTIALLY_PAID' as StatusEnum,
        SHIPPED: 'SHIPPED' as StatusEnum,
        DELIVERED: 'DELIVERED' as StatusEnum,
        ISSUED: 'ISSUED' as StatusEnum,
        CANCELED: 'CANCELED' as StatusEnum,
        CANCELED_BY_SELLER: 'CANCELED_BY_SELLER' as StatusEnum,
        CANCELED_BY_OPERATOR: 'CANCELED_BY_OPERATOR' as StatusEnum,
        AWAITING_ASSEMBLY: 'AWAITING_ASSEMBLY' as StatusEnum,
        ASSEMBLY: 'ASSEMBLY' as StatusEnum,
        ASSEMBLED: 'ASSEMBLED' as StatusEnum,
        WAITING_DELIVERY: 'WAITING_DELIVERY' as StatusEnum,
        RETURNED: 'RETURNED' as StatusEnum,
        TIMEOUT: 'TIMEOUT' as StatusEnum,
        BUY_IN_CREDIT: 'BUY_IN_CREDIT' as StatusEnum,
        STORED: 'STORED' as StatusEnum
    };
    export type OrderActionsEnum = 'ONLINE_PAYMENT' | 'CANCELLATION_BY_BUYER' | 'CANCELLATION_BY_SELLER' | 'CANCELLATION_BY_OPERATOR' | 'REPEAT_ORDER' | 'CREATE_REVIEW' | 'RETURN_ITEM' | 'MARK_AS_DELIVERED' | 'CHANGE_SKU' | 'MARK_AS_REFUND' | 'CHANGE_DELIVERY_PERIOD' | 'CHANGE_TOTAL' | 'RETRY_DELIVERY_CREATE' | 'DISPUTE_CREATE' | 'MARK_IN_ASSEMBLY' | 'MARK_AS_ASSEMBLED' | 'READY_FOR_DELIVERY' | 'UNDER_CONSIDERATION' | 'APPROVE_INTERVIEW' | 'GET_CANDIDATE' | 'APPROVE_AGREEMENT' | 'CANDIDATE_IN_RENT' | 'END_RENT' | 'CLOSE_ORDER_RENT' | 'CREATE_CREDIT_APPLICATION';
    export const OrderActionsEnum = {
        ONLINE_PAYMENT: 'ONLINE_PAYMENT' as OrderActionsEnum,
        CANCELLATION_BY_BUYER: 'CANCELLATION_BY_BUYER' as OrderActionsEnum,
        CANCELLATION_BY_SELLER: 'CANCELLATION_BY_SELLER' as OrderActionsEnum,
        CANCELLATION_BY_OPERATOR: 'CANCELLATION_BY_OPERATOR' as OrderActionsEnum,
        REPEAT_ORDER: 'REPEAT_ORDER' as OrderActionsEnum,
        CREATE_REVIEW: 'CREATE_REVIEW' as OrderActionsEnum,
        RETURN_ITEM: 'RETURN_ITEM' as OrderActionsEnum,
        MARK_AS_DELIVERED: 'MARK_AS_DELIVERED' as OrderActionsEnum,
        CHANGE_SKU: 'CHANGE_SKU' as OrderActionsEnum,
        MARK_AS_REFUND: 'MARK_AS_REFUND' as OrderActionsEnum,
        CHANGE_DELIVERY_PERIOD: 'CHANGE_DELIVERY_PERIOD' as OrderActionsEnum,
        CHANGE_TOTAL: 'CHANGE_TOTAL' as OrderActionsEnum,
        RETRY_DELIVERY_CREATE: 'RETRY_DELIVERY_CREATE' as OrderActionsEnum,
        DISPUTE_CREATE: 'DISPUTE_CREATE' as OrderActionsEnum,
        MARK_IN_ASSEMBLY: 'MARK_IN_ASSEMBLY' as OrderActionsEnum,
        MARK_AS_ASSEMBLED: 'MARK_AS_ASSEMBLED' as OrderActionsEnum,
        READY_FOR_DELIVERY: 'READY_FOR_DELIVERY' as OrderActionsEnum,
        UNDER_CONSIDERATION: 'UNDER_CONSIDERATION' as OrderActionsEnum,
        APPROVE_INTERVIEW: 'APPROVE_INTERVIEW' as OrderActionsEnum,
        GET_CANDIDATE: 'GET_CANDIDATE' as OrderActionsEnum,
        APPROVE_AGREEMENT: 'APPROVE_AGREEMENT' as OrderActionsEnum,
        CANDIDATE_IN_RENT: 'CANDIDATE_IN_RENT' as OrderActionsEnum,
        END_RENT: 'END_RENT' as OrderActionsEnum,
        CLOSE_ORDER_RENT: 'CLOSE_ORDER_RENT' as OrderActionsEnum,
        CREATE_CREDIT_APPLICATION: 'CREATE_CREDIT_APPLICATION' as OrderActionsEnum
    };
    export type PaymentMethodEnum = 'ONLINE' | 'CASH' | 'INVOICE' | 'CREDIT' | 'FACTORING' | 'POSTPONEMENT' | 'REVERSE_FACTORING';
    export const PaymentMethodEnum = {
        ONLINE: 'ONLINE' as PaymentMethodEnum,
        CASH: 'CASH' as PaymentMethodEnum,
        INVOICE: 'INVOICE' as PaymentMethodEnum,
        CREDIT: 'CREDIT' as PaymentMethodEnum,
        FACTORING: 'FACTORING' as PaymentMethodEnum,
        POSTPONEMENT: 'POSTPONEMENT' as PaymentMethodEnum,
        REVERSE_FACTORING: 'REVERSE_FACTORING' as PaymentMethodEnum
    };
    export type PaymentProviderEnum = 'BAKONG' | 'BANQUEMISR' | 'ICICI' | 'RBS' | 'EWALLET';
    export const PaymentProviderEnum = {
        BAKONG: 'BAKONG' as PaymentProviderEnum,
        BANQUEMISR: 'BANQUEMISR' as PaymentProviderEnum,
        ICICI: 'ICICI' as PaymentProviderEnum,
        RBS: 'RBS' as PaymentProviderEnum,
        EWALLET: 'EWALLET' as PaymentProviderEnum
    };
    export type TypeEnum = 'PHYSICAL' | 'DIGITAL' | 'TENDER' | 'INTERVIEW';
    export const TypeEnum = {
        PHYSICAL: 'PHYSICAL' as TypeEnum,
        DIGITAL: 'DIGITAL' as TypeEnum,
        TENDER: 'TENDER' as TypeEnum,
        INTERVIEW: 'INTERVIEW' as TypeEnum
    };
}


